import { Box, Chip } from "@mui/material";
import Actions from "./Actions";
import { useMainContext } from "../../../context/useMainContext";
import { updateUrlParams } from "../../../utils/urlParams";
export default function ActionsPanel() {
  const { filters, setFilters, filtersLogic, setPage, isInitialLoad, saveUndoData } =
    useMainContext();

  const handleDeleteFilter = (index) => {
    const filterToRemove = filters[index];
    const previousFilters = [...filters];
    const updatedFilters = filters.filter((f, i) => {
      if (filterToRemove.id) {
        return f.id !== filterToRemove.id;
      }
      return i !== index;
    });
    const saveData = (filters) => {
      setFilters(filters);
      setPage(0);
      if (!isInitialLoad) {
        updateUrlParams({
          filters,
          logic: filtersLogic,
          page: 0,
        });
      }
    };
    saveData(updatedFilters);
    saveUndoData({
      action: 'Filter removed',
      undoFunction: () => saveData(previousFilters),
      redoFunction: () => saveData(updatedFilters)
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Actions />

      {filters.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {filters?.length > 1 && (
            <Chip
              label={`${filtersLogic.toUpperCase()}`}
              variant="outlined"
              size="small"
              color={filtersLogic === 'and' ? 'success' : 'error'}
            />
          )}
          {filters.map((filter, index) => (
            <Chip
              key={
                filter.id ||
                `${filter.column}-${filter.operator}-${filter.value || ""}-${index}`
              }
              label={`${filter.columnLabel || filter.column}: ${filter.operator} ${filter.label || filter.value || ""}`}
              onDelete={() => handleDeleteFilter(index)}
              variant="filled"
              size="small"
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
